import React from 'react';
import { Grid, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';

const AMOUNTS = [10, 20, 30, 40, 50, 60, 100, 150, 200, 300, 500, 1000];

// Same neutral tone as the calculator keypads (see assets/css/buttons.css)
const shortcutSx = {
  height: '100px',
  width: '100px',
  fontSize: '35px',
  fontWeight: 700,
  color: 'white',
  background: 'linear-gradient(160deg, #9dafbd 0%, #6d8190 100%)',
  boxShadow:
    '0 4px 12px rgba(136,156,171,0.2), inset 0 1px 0 rgba(255,255,255,0.14)',
  borderRadius: '12px',
  transition: 'transform 80ms ease, box-shadow 80ms ease',
  // :hover is stripped app-wide, so press feedback lives on :active
  '&:active': {
    transform: 'translateY(3px)',
    boxShadow:
      '0 2px 6px rgba(0,0,0,0.18), inset 0 1px 0 rgba(255,255,255,0.1)',
  },
};

function Shortcuts({ updateAmountShortcut, isTab }) {
  const { t } = useTranslation();

  return (
    <Grid
      item
      xs={12}
      sx={{
        padding: '10px',
        height: '555px',
        width: '100%',
        marginTop: 0,
        marginLeft: 0,
        justifyContent: 'center',
        alignContent: 'center',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
      }}
    >
      {!isTab && (
        <h2 style={{ textAlign: 'left', width: '100%' }}>
          {t('sales.shortcuts')}
        </h2>
      )}
      <Grid
        container
        flexDirection="row"
        sx={{
          height: '100%',
          width: '100%',
          marginTop: 0,
          marginLeft: 0,
          display: 'flex',
          justifyContent: 'center',
          alignContent: 'center',
          alignItems: 'center',
        }}
      >
        <Grid
          item
          xs={12}
          sx={{
            border: '1px solid #2a3a6e',
            borderRadius: '12px',
            width: '100%',
            maxWidth: '100% !important',
            height: '100%',
            backgroundColor: '#232a45',
          }}
        >
          <Grid
            container
            flexDirection="row"
            sx={{
              height: '100%',
              width: '100%',
              marginTop: 0,
              marginLeft: 0,
              display: 'flex',
              alignContent: 'space-around',
              alignItems: 'center',
              justifyContent: 'center',
            }}
          >
            {AMOUNTS.map((amount) => (
              <Grid
                item
                xs={4}
                key={amount}
                sx={{
                  display: 'flex',
                  alignContent: 'center',
                  alignItems: 'center',
                  justifyContent: 'center',
                }}
              >
                <Button
                  variant="contained"
                  component="label"
                  disableElevation
                  sx={shortcutSx}
                  onClick={() => {
                    updateAmountShortcut(amount);
                  }}
                >
                  {amount}
                </Button>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}

export default Shortcuts;
